import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import Loader from "../layout/Loader";
import { bookeeyPaymentStatus } from "../services/walletService";

const PaymentStatus = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [statusData, setStatusData] = useState(null);
  const [searchParams] = useSearchParams();

  const merchantTxnId = searchParams.get("merchantTxnId");
  const txnId = searchParams.get("txnId");

  let redirectStatus = "";
  try {
    redirectStatus = atob(searchParams.get("finalstatus") || "");
  } catch {
    redirectStatus = "";
  }

  const finalStatus = statusData?.finalStatus || redirectStatus || "failed";
  const isSuccess = finalStatus?.toLowerCase() === "success";

  const checkPaymentStatus = async (transactionId) => {
    try {
      const response = await bookeeyPaymentStatus({ transactionId });

      if (response?.data?.code === 1) {
        setStatusData(response.data.data);
      }
    } catch (err) {
      console.error("Payment status error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!merchantTxnId?.trim()) {
      setIsLoading(false);
      return;
    }

    checkPaymentStatus(merchantTxnId);
  }, [merchantTxnId]);

  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="container">
      <div className="row justify-content-center align-items-center authentication authentication-basic h-100">
        <div className="col-xxl-5 col-xl-5 col-lg-6 col-md-8 col-sm-10 col-12">
          <div className="card custom-card my-4">
            <div className="card-body p-5 text-center">
              {/* Logo */}
              <div className="mb-4 d-flex justify-content-center">
                <Link to="/">
                  <img
                    src="assets/images/brand-logos/desktop-logo.png"
                    alt="logo"
                    className="desktop-logo"
                  />
                  <img
                    src="assets/images/brand-logos/desktop-white.png"
                    alt="logo"
                    className="desktop-white"
                  />
                </Link>
              </div>

              {/* Icon */}
              <div
                className="mb-3"
                style={{
                  animation: "float 3s ease-in-out infinite",
                  display: "inline-block",
                }}
              >
                <i
                  className={
                    isSuccess
                      ? "ri-checkbox-circle-line text-success"
                      : "ri-close-circle-line text-danger"
                  }
                  style={{ fontSize: 68 }}
                />
              </div>

              {/* Title */}
              <p className="h5 mb-2">
                {isSuccess ? "Payment Successful" : "Payment Failed"}
              </p>

              {/* Message */}
              <p className="text-muted mb-4">
                {isSuccess
                  ? "Your payment has been processed successfully."
                  : statusData?.statusDescription ||
                    "Your payment could not be completed."}
              </p>

              {/* Transaction details */}
              <div className="mb-4 text-start">
                <div className="card custom-card">
                  <div className="card-body p-3">
                    {(merchantTxnId || statusData?.bookeeyTrackId) && (
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <small className="text-muted">Reference</small>
                        <small className="fw-medium">
                          {merchantTxnId || statusData?.bookeeyTrackId}
                        </small>
                      </div>
                    )}

                    {(txnId || statusData?.paymentId) && (
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <small className="text-muted">Transaction ID</small>
                        <small className="fw-medium">
                          {txnId || statusData?.paymentId}
                        </small>
                      </div>
                    )}

                    {statusData?.paymentType && (
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <small className="text-muted">Payment Method</small>
                        <small className="fw-medium">
                          {statusData.paymentType}
                        </small>
                      </div>
                    )}

                    <div className="d-flex justify-content-between align-items-center">
                      <small className="text-muted">Status</small>
                      <span
                        className={`badge ${
                          isSuccess ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {finalStatus || "Unknown"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Buttons */}
              <div className="d-grid gap-2">
                <Link to="/wallet" className="btn btn-primary">
                  <i className="ri-wallet-line align-middle me-1" />
                  Go to Wallet
                </Link>

                <Link to="/" className="btn btn-outline-secondary">
                  <i className="ri-arrow-left-line align-middle me-1" />
                  Back to home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }
      `}</style>
    </div>
  );
};

export default PaymentStatus;
